module.exports = __webpack_public_path__ + "static/media/logo.la-spezia.73d154e2.svg";